const PERFIL_USUARIO = 1;
const PERFIL_COLABORADOR = 2;
const PERFIL_CLIENTE = 3;
const PERFIL_EJECUTIVO = 4;

const perfilUsuario = PERFIL_CLIENTE;
const tiempoRecargaAvisos = 60; // En segundos
/*
// TEST
const urlBase = 'https://asurnet-chu.dynalias.com/api/v2/';
const logoClaro = '/clientes/logos/asurnet/logoClaro.png';
const logoOscuro = '/clientes/logos/asurnet/logoOscuro.png';
const nombreCorto = 'Asurnet'
const nombreCorreduria = 'Marín Domenech Correduría de Seguros S.L.'
const direccionCorreduria = 'Avda. del Puerto, Nº 1, Cádiz'
const telefonoCorreduria = '963 841 515 24h / 356 días'
*/
/*
// ADVANS
const urlBase = 'https://advans.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/advans/logoClaro.png';
const logoOscuro = '/clientes/logos/advans/logoOscuro.png';
const nombreCorto = 'Advans'
const nombreCorreduria = 'Advans Broker Correduría de Seguros, S.L.'
const direccionCorreduria = 'Calle Delicias, 5 bajo 13004 Ciudad Real'
const telefonoCorreduria = '926 222 721'
*/
/*
// ALPA
const urlBase = 'https://alpa.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/alpa/logoClaro.png';
const logoOscuro = '/clientes/logos/alpa/logoOscuro.png';
const nombreCorto = 'Alpa'
const nombreCorreduria = 'Correduría de seguros Alpa Alonso García y Pan del Río, S.L.'
const direccionCorreduria = 'Calle Felipe Prieto, 14. 34001 Palencia'
const telefonoCorreduria = '979 750 337'
*/
/*
// BROKALIA
const urlBase = 'https://intranet.brokalia.com/api/v2/';
const logoClaro = '/clientes/logos/brokalia/logoClaro.png';
const logoOscuro = '/clientes/logos/brokalia/logoOscuro.png';
const nombreCorto = 'Brokalia'
const nombreCorreduria = 'Brokalia'
const direccionCorreduria = 'Avda. del Puerto, Nº 1, Cádiz'
const telefonoCorreduria = '918 372 025'
*/
/*
// GARCIA TALAVERA
const urlBase = 'https://garciatalavera.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/garcia-talavera/logoClaro.png';
const logoOscuro = '/clientes/logos/garcia-talavera/logoOscuro.png';
const nombreCorto = 'Garcia-Talavera'
const nombreCorreduria = 'Garcia Talavera Correduría de Seguros, S.L.'
const direccionCorreduria = 'Calle Cartagena, 4, 30400 Caravaca de la Cruz, Murcia'
const telefonoCorreduria = '968 70 23 92'
*/
/*
// GRANDA-BLANCO
const urlBase = 'https://grandablanco.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/granda-blanco/logoClaro.png';
const logoOscuro = '/clientes/logos/granda-blanco/logoOscuro.png';
const nombreCorto = 'Grabda-Blanco'
const nombreCorreduria = 'Granda Blanco Oviedo Correduría de Seguros, S.L.'
const direccionCorreduria = 'C\Alcalde Garcia Conde, 13, 1 - 33001 OVIEDO (Asturias)'
const telefonoCorreduria = '985 21 12 85'
*/
/*
// HERMANOS NUÑEZ
const urlBase = 'https://hnl.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/hnl/logoClaro.png';
const logoOscuro = '/clientes/logos/hnl/logoOscuro.png';
const nombreCorto = 'Hermanos-Nuñez-Lorenzo'
const nombreCorreduria = 'Hermanos Núñez Lorenzo, S.L.'
const direccionCorreduria = 'Praza do Concello, Nº8, 36470 Salceda de Caselas, Pontevedra'
const telefonoCorreduria = '986 34 90 75'
*/
/*
// JORI ARMENGOL
const urlBase = 'https://mediavanz.joriarmengol.com/api/v2/';
const logoClaro = '/clientes/logos/jori-armengol/logoClaro.png';
const logoOscuro = '/clientes/logos/jori-armengol/logoOscuro.png';
const nombreCorto = 'Jori-Armengol'
const nombreCorreduria = 'Jori Armengol y Asociados Correduría de Seguros S.A.'
const direccionCorreduria = 'Carrer de Roger de Llúria, 124, 08037 Barcelona'
const telefonoCorreduria = '934 76 33 50'
*/
/*
// MARIN
const urlBase = 'https://www.marindomenech.info/api/v2/';
const logoClaro = '/clientes/logos/marin/logoClaro.png';
const logoOscuro = '/clientes/logos/marin/logoOscuro.png';
const nombreCorto = 'Marin'
const nombreCorreduria = 'Marín Domenech Correduría de Seguros S.L.'
const direccionCorreduria = 'Avda. del Puerto, Nº 1, Cádiz'
const telefonoCorreduria = '956 25 29 90'
*/
/*
// PEREZ TORREGROSA
const urlBase = 'https://intranet.pthseguros.com/api/v2/';
const logoClaro = '/clientes/logos/perez-torregrosa/logoClaro.png';
const logoOscuro = '/clientes/logos/perez-torregrosa/logoOscuro.png';
const nombreCorto = 'Perez-Torregrosa'
const nombreCorreduria = 'Pérez Torregrosa & Hijos S.L.'
const direccionCorreduria = 'Calle Gaspar Méndez, 1. Planta 2, Oficina 6, 06011, Badajoz.'
const telefonoCorreduria = '924 241 500'
*/

// RUIZRE
const urlBase = 'https://app.ruizre.es/api/v2/';
const logoClaro = '/clientes/logos/ruizre/logoClaro.png';
const logoOscuro = '/clientes/logos/ruizre/logoOscuro.png';
const nombreCorto = 'Ruizre'
const nombreCorreduria = 'Ruiz Re Correduría de Seguros S.L.'
const direccionCorreduria = 'C/ Sierra de la Carrasquilla, 6 Lorca (Murcia)'
const telefonoCorreduria = '968 46 86 93 24h / 365 días'

/*
// SEGURANTIA
const urlBase = 'https://segurantia.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/segurantia/logoClaro.png';
const logoOscuro = '/clientes/logos/segurantia/logoOscuro.png';
const nombreCorto = 'Segurantia'
const nombreCorreduria = 'Segurantia, Correduría de Seguros, S.L.'
const direccionCorreduria = 'Plaza del Pilar, nº 16 Principal Dcha. 50003 Zaragoza'
const telefonoCorreduria = '976 211 010'
*/
/*
// SERRANO Y REVERTE
const urlBase = 'http://serranoyreverte.mediavanz.net:8081/api/v2/';
const logoClaro = '/clientes/logos/serrano-reverte/logoClaro.png';
const logoOscuro = '/clientes/logos/serrano-reverte/logoOscuro.png';
const nombreCorto = 'Serrano-Reverte'
const nombreCorreduria = 'Serrano y Reverte Correduría de Seguros, S.L.'
const direccionCorreduria = 'Serrallo, 1-Bajo 30800 Lorca'
const telefonoCorreduria = '968 468 339'
*/
/*
// TXARROALDE
const urlBase = 'https://txarroalde.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/txarroalde/logoClaro.png';
const logoOscuro = '/clientes/logos/txarroalde/logoOscuro.png';
const nombreCorto = 'Txarroalde'
const nombreCorreduria = 'Txarroalde Correduría de Seguros, S.L.'
const direccionCorreduria = 'Alameda de Recalde, 21, 48009 Bilbao, Vizcaya'
const telefonoCorreduria = '944 35 60 80'
*/
/*
// VEAR NORTE
const urlBase = 'https://vearnorte.mediavanz.net/api/v2/';
const logoClaro = '/clientes/logos/vear-norte/logoClaro.png';
const logoOscuro = '/clientes/logos/vear-norte/logoOscuro.png';
const nombreCorto = 'Vear-Norte'
const nombreCorreduria = 'Vear Norte Correduría de Seguros, S.L.'
const direccionCorreduria = 'Av. de los Castros, 139, 39012 Santander, Cantabria'
const telefonoCorreduria = '942 32 14 05'
*/

export default {
  perfilUsuario,
  urlBase,
  logoClaro,
  logoOscuro,
  tiempoRecargaAvisos,
  nombreCorreduria,
  direccionCorreduria,
  nombreCorto,
  telefonoCorreduria
}
